import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({
  template: `<img style="max-height: 100%; max-width: 100%" [src]="params.data.imageUrl" /> `,
})
export class ImageTableComponent implements AgRendererComponent {
  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(params: any): boolean {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/ag-grid/image-table.component.ts